var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12 default"},[_c('system-info')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }